import { redirect, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetCampaignDetailsPageParams = () => {
	const { hotelID, campaignID } = useParams<ParamParseKey<typeof PATHS.HOTEL.MARKETING.CAMPAIGN.DETAILS>>();

	if (!hotelID || !campaignID) {
		redirect("/");
	}

	return { hotelID: hotelID!, campaignID: campaignID! };
};
